var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackgroundGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.790039,
    width: 60,
    height: 60,
    rx: 16,
    fill: "#70E7B8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8337_42774)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8337_42774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0003 17.457V44.1237H24.4137C19.5603 44.1237 16.667 41.2303 16.667 36.377V25.2037C16.667 20.3504 19.5603 17.457 24.4137 17.457H25.0003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3333 25.2037V29.7903H27V17.457H35.5867C40.44 17.457 43.3333 20.3504 43.3333 25.2037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3333 31.79V36.3767C43.3333 41.23 40.44 44.1233 35.5867 44.1233H27V31.79H43.3333Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8337_42774"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14.79,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8337_42774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(14 14.79)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundGreen);
export default __webpack_public_path__ + "static/media/backgroundGreen.a27eac40b982e5fa6c54d899610ea7b9.svg";
export { ForwardRef as ReactComponent };